// @ts-check

const countryWithProvince = ["IT", "ES", "PT"];

// Shared config for "materials" and "message" contact types.
// "materials" is used in information-request-form ("Information material").
// "message" is used in dealer-request-form ("Compose message").
// Both trigger identical behavior.
const materialsMessageConfig = {
	selectors: [
		".js-Interest",
		".js-AdditionalInformation",
		".js-PersonalInformation",
		".js-Privacy",
	],
	fields: ["interest", "additionalInformation", "personalData", "privacy"],
};

// Shared mapping of contact types to their DOM selectors and logical field groups.
// Used by both the dealer request form UI and validation layer.
const CONTACT_TYPE_CONFIG = {
	"quote-request": {
		selectors: [
			".js-ConstructionType",
			".js-DoorsInterest",
			".js-FrameMaterials",
			".js-Address",
			".js-AdditionalInformation",
			".js-MediaUpload",
			".js-PersonalInformation",
			".js-OtherAddress",
			".js-Privacy",
		],
		fields: [
			"constructionType",
			"doorsInterest",
			"frameMaterial",
			"address",
			"additionalInformation",
			"mediaUpload",
			"personalData",
			"otherAddress",
			"privacy",
		],
	},
	"on-site-appointment": {
		selectors: [
			".js-Interest",
			".js-DayTime",
			".js-AdditionalInformation",
			".js-PersonalInformation",
			".js-Address",
			".js-Privacy",
		],
		fields: [
			"interest",
			"dayTime",
			"additionalInformation",
			"personalData",
			"address",
			"privacy",
		],
	},
	"showroom-appointment": {
		selectors: [
			".js-Interest",
			".js-DayTime",
			".js-AdditionalInformation",
			".js-PersonalInformation",
			".js-Privacy",
		],
		fields: [
			"interest",
			"dayTime",
			"additionalInformation",
			"personalData",
			"privacy",
		],
	},
	materials: materialsMessageConfig,
	message: materialsMessageConfig,
};
// Shared codes use parent (e.g. IC → Spain +34, EA → Spain +34).
// Territories with no allocation (AQ, BV, HM, TF, CP) use "".
// NANP regions all use +1.
/** @type {Record<string, string>} */
const countryDialCodeMap = {
	DE: "+49",
	IT: "+39",
	GB: "+44",
	FR: "+33",
	ES: "+34",
	NL: "+31",
	BE: "+32",
	SI: "+386",
	CZ: "+420",
	PT: "+351",
	AF: "+93",
	AX: "+358",
	AL: "+355",
	DZ: "+213",
	AS: "+1",
	AD: "+376",
	AO: "+244",
	AI: "+1",
	AQ: "",
	AG: "+1",
	AR: "+54",
	AM: "+374",
	AW: "+297",
	AC: "+247",
	AU: "+61",
	AT: "+43",
	AZ: "+994",
	BS: "+1",
	BH: "+973",
	BD: "+880",
	BB: "+1",
	BY: "+375",
	BZ: "+501",
	BJ: "+229",
	BM: "+1",
	BT: "+975",
	BO: "+591",
	BA: "+387",
	BW: "+267",
	BV: "",
	BR: "+55",
	IO: "+246",
	VG: "+1",
	BN: "+673",
	BG: "+359",
	BF: "+226",
	BI: "+257",
	KH: "+855",
	CM: "+237",
	CA: "+1",
	IC: "+34",
	CV: "+238",
	BQ: "+599",
	KY: "+1",
	CF: "+236",
	EA: "+34",
	TD: "+235",
	CL: "+56",
	CN: "+86",
	CX: "+61",
	CP: "",
	CC: "+61",
	CO: "+57",
	KM: "+269",
	CG: "+242",
	CD: "+243",
	CK: "+682",
	CR: "+506",
	CI: "+225",
	HR: "+385",
	CU: "+53",
	CW: "+599",
	CY: "+357",
	DK: "+45",
	DG: "+246",
	DJ: "+253",
	DM: "+1",
	DO: "+1",
	EC: "+593",
	EG: "+20",
	SV: "+503",
	GQ: "+240",
	ER: "+291",
	EE: "+372",
	SZ: "+268",
	ET: "+251",
	FK: "+500",
	FO: "+298",
	FJ: "+679",
	FI: "+358",
	GF: "+594",
	PF: "+689",
	TF: "",
	GA: "+241",
	GM: "+220",
	GE: "+995",
	GH: "+233",
	GI: "+350",
	GR: "+30",
	GL: "+299",
	GD: "+1",
	GP: "+590",
	GU: "+1",
	GT: "+502",
	GG: "+44",
	GN: "+224",
	GW: "+245",
	GY: "+592",
	HT: "+509",
	HM: "",
	HN: "+504",
	HK: "+852",
	HU: "+36",
	IS: "+354",
	IN: "+91",
	ID: "+62",
	IR: "+98",
	IQ: "+964",
	IE: "+353",
	IM: "+44",
	IL: "+972",
	JM: "+1",
	JP: "+81",
	JE: "+44",
	JO: "+962",
	KZ: "+7",
	KE: "+254",
	KI: "+686",
	XK: "+383",
	KW: "+965",
	KG: "+996",
	LA: "+856",
	LV: "+371",
	LB: "+961",
	LS: "+266",
	LR: "+231",
	LY: "+218",
	LI: "+423",
	LT: "+370",
	LU: "+352",
	MO: "+853",
	MG: "+261",
	MW: "+265",
	MY: "+60",
	MV: "+960",
	ML: "+223",
	MT: "+356",
	MH: "+692",
	MQ: "+596",
	MR: "+222",
	MU: "+230",
	YT: "+262",
	MX: "+52",
	FM: "+691",
	MD: "+373",
	MC: "+377",
	MN: "+976",
	ME: "+382",
	MS: "+1",
	MA: "+212",
	MZ: "+258",
	MM: "+95",
	NA: "+264",
	NR: "+674",
	NP: "+977",
	NC: "+687",
	NZ: "+64",
	NI: "+505",
	NE: "+227",
	NG: "+234",
	NU: "+683",
	NF: "+672",
	KP: "+850",
	MK: "+389",
	MP: "+1",
	NO: "+47",
	OM: "+968",
	PK: "+92",
	PW: "+680",
	PS: "+970",
	PA: "+507",
	PG: "+675",
	PY: "+595",
	PE: "+51",
	PH: "+63",
	PN: "+64",
	PL: "+48",
	PR: "+1",
	QA: "+974",
	RE: "+262",
	RO: "+40",
	RU: "+7",
	RW: "+250",
	WS: "+685",
	SM: "+378",
	ST: "+239",
	SA: "+966",
	SN: "+221",
	RS: "+381",
	SC: "+248",
	SL: "+232",
	SG: "+65",
	SX: "+1",
	SK: "+421",
	SB: "+677",
	SO: "+252",
	ZA: "+27",
	GS: "+500",
	KR: "+82",
	SS: "+211",
	LK: "+94",
	BL: "+590",
	SH: "+290",
	KN: "+1",
	LC: "+1",
	MF: "+590",
	PM: "+508",
	VC: "+1",
	SD: "+249",
	SR: "+597",
	SJ: "+47",
	SE: "+46",
	CH: "+41",
	SY: "+963",
	TW: "+886",
	TJ: "+992",
	TZ: "+255",
	TH: "+66",
	TL: "+670",
	TG: "+228",
	TK: "+690",
	TO: "+676",
	TT: "+1",
	TA: "+290",
	TN: "+216",
	TR: "+90",
	TM: "+993",
	TC: "+1",
	TV: "+688",
	UM: "+1",
	VI: "+1",
	UG: "+256",
	UA: "+380",
	AE: "+971",
	US: "+1",
	UY: "+598",
	UZ: "+998",
	VU: "+678",
	VA: "+39",
	VE: "+58",
	VN: "+84",
	WF: "+681",
	EH: "+212",
	YE: "+967",
	ZM: "+260",
	ZW: "+263",
};
const fallbackCountry = "IT";

/**
 * Formats raw consent data by checking for the presence of specific consent fields.
 * @param {object} rawConsentData - The raw consent data object to be formatted.
 * @returns {object} An object with boolean values indicating the presence of:
 *   - dataProcessing
 *   - consentToContact
 *   - consentToContactPartner
 */
const getFormattedConsentFields = (rawConsentData) => {
	return {
		dataProcessing: Object.hasOwn(rawConsentData, "dataProcessing"),
		consentToContact: Object.hasOwn(rawConsentData, "consentToContact"),
		consentToContactPartner: Object.hasOwn(
			rawConsentData,
			"consentToContactPartner",
		),
	};
};

/**
 * @param {Element} element
 * @param {string} attribute
 * @returns {string[]}
 */
const getAttributeTokens = (element, attribute) => {
	return (element.getAttribute(attribute) || "").split(/\s+/).filter(Boolean);
};

/**
 * Sets an attribute to a space-separated list of tokens. Deduplicates but does not
 * remove the attribute; callers must handle the empty case.
 * @param {Element} element
 * @param {string} attribute
 * @param {string[]} tokens
 */
const setAttributeTokens = (element, attribute, tokens) => {
	const uniqueTokens = [...new Set(tokens)];
	if (uniqueTokens.length === 0) {
		return;
	}
	element.setAttribute(attribute, uniqueTokens.join(" "));
};

/**
 * @param {Element} element
 * @param {string} attribute
 * @param {string} token
 */
const addAttributeToken = (element, attribute, token) => {
	setAttributeTokens(element, attribute, [
		...getAttributeTokens(element, attribute),
		token,
	]);
};

/**
 * @param {Element} element
 * @param {string} attribute
 * @param {string} token
 */
const removeAttributeToken = (element, attribute, token) => {
	const tokens = getAttributeTokens(element, attribute).filter(
		(currentToken) => currentToken !== token,
	);

	if (!tokens.length) {
		element.removeAttribute(attribute);
		return;
	}

	setAttributeTokens(element, attribute, tokens);
};

/**
 * @param {Element} field
 * @param {string} errorId
 */
const linkErrorToField = (field, errorId) => {
	addAttributeToken(field, "aria-describedby", errorId);
	addAttributeToken(field, "aria-errormessage", errorId);
};

/**
 * @param {Element} field
 * @param {string} errorId
 */
const unlinkErrorFromField = (field, errorId) => {
	removeAttributeToken(field, "aria-describedby", errorId);
	removeAttributeToken(field, "aria-errormessage", errorId);
};

/**
 * Displays validation errors on the form.
 * @param {NonNullable<import("./shared-schemas.js").ValidationResult["errors"]>} errors - The errors object containing field errors.
 * @param {HTMLElement} $this - The element containing the fields to display errors for.
 */
const displayErrors = (errors, $this) => {
	const fieldErrors = /** @type {Record<string, string[]>} */ (
		errors.fieldErrors
	);

	/** @type {?HTMLElement} firstError */
	let firstError = null;
	Object.keys(fieldErrors).forEach((field, index) => {
		// For backward compatibility with old forms some fields have the edit- prefix
		// we need to prepend this to new fields
		const errorFieldId = `#${field === "province" ? "edit-province" : field === "other-province" ? "other-edit-province" : field}`;
		/** @type {?HTMLElement} */
		let errorField = $this.querySelector(errorFieldId);
		/** @type {?HTMLElement} */
		const errorElement = $this.querySelector(`#${field}Error`);

		if (errorElement) {
			errorElement.textContent = fieldErrors[field][0];
			errorElement.hidden = false;
		}

		if (errorField) {
			errorField.setAttribute("aria-invalid", "true");
			if (errorElement?.id) {
				linkErrorToField(errorField, errorElement.id);
			}
		} else if (errorElement?.closest("fieldset")) {
			const fieldset = /** @type {HTMLFieldSetElement} */ (
				errorElement.closest("fieldset")
			);
			const inputs = Array.from(fieldset.querySelectorAll("input"));
			if (!inputs) {
				return;
			}
			errorField = fieldset;
			inputs.forEach((input) => {
				input.setAttribute("aria-invalid", "true");
				if (errorElement.id) {
					linkErrorToField(input, errorElement.id);
				}
			});
		}

		if (index === 0) {
			firstError = errorField;
		}
	});

	if (firstError) {
		/** @type {HTMLElement} */ (firstError).focus();
	}
};

/**
 * Hides all error messages and removes error indicators within the given element.
 * @param {HTMLElement} $this - The root element within which to hide all errors.
 */
const hideAllErrors = ($this) => {
	const errorFields = $this.querySelectorAll("[aria-invalid=true]");
	const describedByFields = $this.querySelectorAll(
		"[aria-describedby], [aria-errormessage]",
	);
	const errorElements = $this.querySelectorAll(".Error");
	errorFields.forEach((errorField) => {
		errorField.removeAttribute("aria-invalid");
	});
	errorElements.forEach((errorElement) => {
		if (errorElement.id) {
			describedByFields.forEach((field) => {
				unlinkErrorFromField(field, errorElement.id);
			});
		}
		/** @type {HTMLElement} */ (errorElement).hidden = true;
		errorElement.textContent = "";
	});
};

/**
 * @deprecated Resets the form error state by clearing aria-invalid attributes and error messages.
 * @param {HTMLElement} container - The container element that holds the form fields.
 * @public
 * @returns {void}
 */
const resetFormErrorState = (container) => {
	const ariaInvalidFields = Array.from(
		container.querySelectorAll("[aria-invalid=true]"),
	);
	const validationErrorContainers = Array.from(
		container.querySelectorAll(".Form-fieldGroupError"),
	);

	if (ariaInvalidFields) {
		ariaInvalidFields.forEach((field) => {
			field.removeAttribute("aria-invalid");
		});
	}

	if (validationErrorContainers) {
		validationErrorContainers.forEach((container) => {
			/** @type {HTMLSpanElement} */ (
				container.querySelector("span")
			).textContent = "";
			container.classList.remove("Form-fieldGroupError--show");
		});
	}
};

/**
 * Asynchronously fetches information about the user's location.
 * @async
 * @returns {Promise<{ countryCode: string }>} The resolved country code, or a fallback value if the request fails.
 */
const getLocationData = async () => {
	const response = await fetch("/api/location");
	if (response.status === 200) {
		// if we got a 200 response, we have a valid country code
		// @see web/modules/custom/finstral_job/src/Plugin/rest/resource/IpLocationResource.php
		const data = await response.json();
		return {
			countryCode: data.country_code,
		};
	}
	return {
		countryCode: fallbackCountry,
	};
};

/**
 * @typedef {object} Province
 * @property {string} province_code - Machine value submitted with the form
 * @property {string} province_label - Human-readable option label
 */

/**
 * Fetches the provinces for a country.
 * @param {string} countryCode - Lower-case ISO country code.
 * @param {string} [endpoint] - Province endpoint; the backend can point a form
 *   at a restricted list via the address section's `provinces_url`
 *   (FINSTRAL-2373). (default: "/api/provinces")
 * @returns {Promise<Province[] | undefined>} The provinces, or `undefined` for
 *   responses other than 200/404.
 */
const getProvincesForCountry = async (
	countryCode,
	endpoint = "/api/provinces",
) => {
	// The calling function is responsible for handling any errors as
	// we need to show a user friendly error message in the UI.
	const separator = endpoint.includes("?") ? "&" : "?";
	const response = await fetch(
		`${endpoint}${separator}country_code=${countryCode}`,
	);

	if (response.status === 200) {
		const data = await response.json();
		return data.provinces;
	} else if (response.status === 404) {
		throw new Error(`Country code ${countryCode} or service not found`);
	}
};

/**
 * Shows or clears the province field's error message.
 * @param {HTMLElement} province - The province field.
 * @param {boolean} [clear] - Clear the error instead of showing it. (default: false)
 */
const updateProvinceErrorState = (province, clear = false) => {
	// province.closest(".js-FormElement") is used for the older Jobs application form
	// @see apps/component-library/src/components/patterns/application-form/application-form.twig
	const provinceFieldGroup =
		province.closest(".js-Form-fieldGroup") ||
		province.closest(".js-FormElement");
	/** @type {HTMLElement | null} */
	const errorContainer = /** @type {Element} */ (
		provinceFieldGroup
	).querySelector(".Error");

	if (!errorContainer) {
		return;
	}

	if (clear) {
		errorContainer.textContent = "";
		errorContainer.hidden = true;
		return;
	}

	if (provinceFieldGroup) {
		errorContainer.textContent = /** @type {string} */ (province.dataset.error);
		errorContainer.hidden = false;
		errorContainer.focus();
	}
};

/**
 * Updates the state of the province input field and its associated label to reflect whether it is required.
 * @param {boolean} required - Indicates if the province field should be required.
 * @param {HTMLSelectElement} province - The province element to update.
 * @param {string} [countryCode] - The country code to get the provinces for. Required when `withOptions` is true.
 * @param {boolean} [withOptions] - Whether to append option elements to the province element. (default: false)
 * @param {?HTMLElement} [label] - The label element to update. Falls back to `#edit-province`'s label when omitted.
 * @param {object} [options] - Optional trailing options.
 * @param {() => boolean} [options.isSectionActive] - Guard invoked before touching state; when it
 *   returns false the province field is left untouched and no provinces are fetched. Opt-in so
 *   existing callers (all other consumer forms) keep their current unconditional behavior.
 */
const updateProvinceState = async (
	required,
	province,
	countryCode,
	withOptions = false,
	label = null,
	{ isSectionActive = () => true } = {},
) => {
	if (!isSectionActive()) {
		return;
	}

	const asterisk = `<span aria-hidden="true">*</span>`;
	const resolvedLabel = /** @type {HTMLElement} */ (
		label || document.querySelector('label[for="edit-province"]')
	);

	updateProvinceErrorState(province, true);

	if (resolvedLabel.dataset.labelText) {
		const labelText = resolvedLabel.dataset.labelText;
		resolvedLabel.innerHTML = required ? `${labelText}${asterisk}` : labelText;
	} else if (resolvedLabel.innerHTML) {
		// This is kept for historical forms. Going forward,
		// the above approach should be used along with the
		// address form component.
		// @see src/components/patterns/form-section/address/address.twig
		const labelText = resolvedLabel.innerHTML;
		resolvedLabel.innerHTML = required
			? `${labelText}${asterisk}`
			: labelText.replace(asterisk, "");
	}

	if (withOptions) {
		let provinces;
		try {
			if (province.dataset.provinces) {
				// Inline province list from the backend — no network fetch needed.
				provinces = /** @type {Province[]} */ (
					JSON.parse(province.dataset.provinces)
				);
			}
			else {
				provinces = /** @type {Province[]} */ (
					await getProvincesForCountry(
						/** @type {string} */ (countryCode).toLowerCase(),
						province.dataset.provincesUrl,
					)
				);
			}
		} catch {
			updateProvinceErrorState(province);
			return;
		}

		if (!provinces.length) {
			return;
		}

		const provinceOptions = provinces.map((province) => {
			const option = document.createElement("option");
			option.value = province.province_code;
			option.textContent = province.province_label;
			return option;
		});

		const defaultOption = /** @type {HTMLOptionElement} */ (
			province.querySelector("option[value='']")
		);
		province.innerHTML = "";
		province.append(...[defaultOption, ...provinceOptions]);
	}

	province.required = required;
	province.setAttribute("aria-required", String(required));
	province.disabled = !required ? true : false;
};

/**
 * Initializes the country, province, and nationality form fields based on the user's country code.
 *
 * - Sets the country and nationality (if enabled) fields to the detected country code.
 * - Updates the province field's state depending on whether the country has provinces.
 * @async
 * @function
 * @param {boolean} hasNationality - Whether to set the nationality field as well. (default: true)
 * @returns {Promise<void>} Resolves when the fields have been initialized.
 */
const initCountryAndNationality = async (hasNationality = true) => {
	const [country, province, nationality] = document.querySelectorAll(
		"#edit-country, #edit-province, #edit-nationality",
	);

	const { countryCode } = await getLocationData();
	const countryHasProvince = countryWithProvince.includes(countryCode);

	if (!countryCode || !/^[A-Z]{2}$/.test(countryCode)) {
		return;
	}

	/** @type {HTMLSelectElement} */ (country).value = countryCode;

	if (hasNationality) {
		/** @type {HTMLSelectElement} */ (nationality).value = countryCode;
	}

	updateProvinceState(
		countryHasProvince,
		/** @type {HTMLSelectElement} */ (province),
	);
};

/**
 * Processes phone number field data, removing incomplete entries.
 * @template {Record<string, unknown>} T
 * @param {string} phoneNumber - The phone number as a string.
 * @param {T} data - The data object containing form data.
 * @param {number} [minAllowedLength] - Minimum required length for a valid phone number. (default: 3)
 * @returns {T} The data object with phone field removed if validation fails.
 */
const processPhoneField = (phoneNumber, data, minAllowedLength = 3) => {
	if (!phoneNumber) {
		return data;
	}

	const hasPossibleValidPhoneNumber = phoneNumber.length > minAllowedLength;

	if (!hasPossibleValidPhoneNumber) {
		delete data.phone;
	}

	return data;
};

/**
 * Swaps the dial code prefix in the phone field for the selected country's.
 * @param {string} countryCode - ISO country code.
 * @param {HTMLInputElement} phoneNumberField - The phone number input.
 */
const updateDialCode = (countryCode, phoneNumberField) => {
	const currentDialingCode = /** @type {string} */ (
		phoneNumberField.dataset.dialCode
	);
	const newDialingCode = countryDialCodeMap[countryCode];
	if (currentDialingCode !== newDialingCode) {
		phoneNumberField.value = phoneNumberField.value.replace(
			currentDialingCode,
			newDialingCode,
		);
		phoneNumberField.dataset.dialCode = newDialingCode;
	}
};

/**
 * @typedef {object} BaseFormOptions
 * @property {boolean} [hasNationality] - Prefill `#edit-nationality` with the detected country.
 * @property {boolean} [hasPhoneNumber] - Prefill and keep `#phone`'s dial code in sync.
 * @property {boolean} [hasProvince] - Manage the `#edit-province` field.
 * @property {boolean} [hasOtherProvince] - Manage the `#other-edit-province` field.
 * @property {() => boolean} [isProvinceSectionActive] - Guard forwarded to `updateProvinceState`.
 */

/**
 * Prefills country-dependent fields and wires up country change handling.
 * @param {HTMLFormElement | null} form - The form element.
 * @param {BaseFormOptions} options - Which fields to manage.
 * @returns {Promise<void>}
 */
const initBaseForm = async (form, options) => {
	if (!form) {
		throw new Error("Form element required but not specified");
	}

	const {
		hasNationality,
		hasPhoneNumber,
		hasProvince,
		hasOtherProvince,
		isProvinceSectionActive = () => true,
	} = options;
	const { countryCode } = await getLocationData();
	const dialingCode = countryDialCodeMap[countryCode];

	/** @type {HTMLSelectElement | HTMLInputElement | null} */
	const countryField = form.querySelector("#edit-country");
	// A country pinned by the backend (address section `fixed_country`) wins
	// over the visitor's location, for the field and the province lookup.
	const isCountryFixed = countryField?.dataset.fixed !== undefined;
	const addressCountryCode = isCountryFixed
		? /** @type {HTMLInputElement} */ (countryField).value
		: countryCode;
	if (countryField && !isCountryFixed) {
		countryField.value = countryCode;
	}

	/** @type {HTMLSelectElement | null} */
	const nationalityField = form.querySelector("#edit-nationality");
	if (hasNationality && nationalityField) {
		nationalityField.value = countryCode;
	}

	/** @type {HTMLInputElement | null} */
	const phoneNumberField = form.querySelector("#phone");
	if (hasPhoneNumber && phoneNumberField) {
		phoneNumberField.value = dialingCode;
		phoneNumberField.dataset.dialCode = dialingCode;
	}

	/** @type {HTMLSelectElement | null} */
	const provinceField = form.querySelector("#edit-province");
	if (hasProvince && provinceField) {
		const countryHasProvince = countryWithProvince.includes(addressCountryCode);
		updateProvinceState(
			countryHasProvince,
			provinceField,
			addressCountryCode,
			/* withOptions */ true,
			/* label */ null,
			{ isSectionActive: isProvinceSectionActive },
		);
	}

	if (countryField) {
		/** @type {HTMLSelectElement} */ (countryField).addEventListener(
			"change",
			(/** @type {Event} */ event) => {
				const countryCode = /** @type {HTMLSelectElement} */ (event.target)
					?.value;

				if (!countryCode) {
					return;
				}

				if (hasPhoneNumber && phoneNumberField) {
					updateDialCode(countryCode, phoneNumberField);
				}

				if (hasProvince && provinceField) {
					const countryHasProvince = countryWithProvince.includes(countryCode);
					updateProvinceState(
						countryHasProvince,
						provinceField,
						countryCode,
						/* withOptions */ countryHasProvince,
						/* label */ null,
						{ isSectionActive: isProvinceSectionActive },
					);
				}
			},
		);
	}

	const otherCountryField = form.querySelector("#other-edit-country");
	/** @type {HTMLSelectElement | null} */
	const otherProvinceField = form.querySelector("#other-edit-province");
	/** @type {HTMLLabelElement | null} */
	const otherProvinceLabel = form.querySelector(
		'label[for="other-edit-province"]',
	);

	if (hasOtherProvince && otherCountryField && otherProvinceField) {
		otherCountryField.addEventListener(
			"change",
			(/** @type {Event} */ event) => {
				const code = /** @type {HTMLSelectElement} */ (event.target)?.value;
				if (!code) return;
				const hasProvince = countryWithProvince.includes(code);
				updateProvinceState(
					hasProvince,
					otherProvinceField,
					code,
					hasProvince,
					otherProvinceLabel,
				);
			},
		);
	}
};

/**
 * Reads and parses JSON from a `<script type="application/json">` element
 * scoped to a container.
 * @param {Element} container - Element to search within.
 * @param {string} selector - CSS selector for the script element.
 * @param {unknown} [fallback] - Value returned when element is missing or JSON is invalid.
 * @returns {ReturnType<typeof JSON.parse>} Parsed JSON (untyped, as from `JSON.parse`) or fallback.
 */
const getEmbeddedJson = (container, selector, fallback = null) => {
	const el = container.querySelector(selector);
	if (!el) {
		return fallback;
	}
	try {
		return JSON.parse(el.textContent);
	} catch {
		return fallback;
	}
};

/** @type {string | null} */
let _token = null;
let _refreshStarted = false;

// "Follows" FormTokenAccessCheck::MIN_AGE_SECONDS — token must age this long
// before the server accepts it, so we delay activating a freshly-fetched token.
// NOTE: TOKEN_DWELL_MS > FormTokenAccessCheck::MIN_AGE_SECONDS by design.
const TOKEN_DWELL_MS = 10000;

/**
 * Fetches a token from the endpoint and activates it.
 *
 * On the first call (_token is null) the token is activated immediately —
 * the user filling out the form provides the required dwell time naturally.
 *
 * On subsequent (refresh) calls the token is held back for TOKEN_DWELL_MS
 * before replacing the current one, so the server's dwell check is satisfied
 * before the new token is ever sent with a submission. The old token remains
 * active during that window and is well within its TTL.
 */
const _fetchAndSetToken = async () => {
	const controller = new AbortController();
	const timeout = setTimeout(() => controller.abort(), 30000);
	try {
		const response = await fetch("/api/form-token", {
			signal: controller.signal,
		});
		if (!response.ok) {
			throw new Error(`${response.status} ${response.statusText}`);
		}
		const { token } = await response.json();
		if (!token) {
			throw new Error("response missing token field");
		}
		if (_token === null) {
			_token = token;
		} else {
			setTimeout(() => {
				_token = token;
			}, TOKEN_DWELL_MS);
		}
	} catch (error) {
		if (/** @type {Error} */ (error).name === "AbortError") {
			console.warn("form token: request timed out");
		} else {
			console.error("form token:", error);
		}
	} finally {
		clearTimeout(timeout);
	}
};

/**
 * Schedules periodic form token refresh, triggered on first form interaction.
 * Fetches a token immediately and refreshes every 10 minutes to stay within
 * the server-side TTL. Dwell validation is handled server-side. Safe to call
 * from multiple components — only the first call starts the cycle.
 */
const scheduleFormTokenRefresh = () => {
	if (_refreshStarted) {
		return;
	}
	_refreshStarted = true;
	_fetchAndSetToken();
	setInterval(_fetchAndSetToken, 10 * 60 * 1000);
};

/**
 * Returns the X-Form-Token header if a token has been fetched, otherwise an
 * empty object. An absent token causes the server to reject the submission with
 * 403 — intentional for submissions that arrive before the dwell time has passed.
 * @returns {Record<string, string>}
 */
const getFormTokenHeaders = () => (_token ? { "X-Form-Token": _token } : {});

export {
	countryWithProvince,
	CONTACT_TYPE_CONFIG,
	displayErrors,
	getEmbeddedJson,
	getFormTokenHeaders,
	scheduleFormTokenRefresh,
	getLocationData,
	getFormattedConsentFields,
	getProvincesForCountry,
	hideAllErrors,
	initBaseForm,
	initCountryAndNationality,
	processPhoneField,
	resetFormErrorState,
	updateProvinceState,
};
